import { useCallback } from 'react'
import { z } from 'zod'
import { FieldPath, useForm } from 'react-hook-form'
import { ReservationTimeSchema } from './reservation-time-new-form-schema'
import { zodResolver } from '@hookform/resolvers/zod'
import { useTranslation } from 'react-i18next'
import { getReservationTimeNewFormSchema } from './reservation-time-new-form-schema'
import { useCustomError } from 'src/utils/custom-errors.hook'
import { FetchResult } from '@apollo/client'
import { ReservationCreateMutation } from 'src/api/api.generated'

type props = {
  onSubmit: (data: ReservationTimeSchema) => Promise<FetchResult<ReservationCreateMutation> | undefined>
  openReservation?: (reservationId: string) => void
}

// export function formSchemaAsReservationFormData(data: ReservationTimeSchema): ReservationTimeSchema | undefined {
//   if (data.reservationDate.checkIn && data.reservationDate.checkOut && data.reservationTime.start && data.reservationTime.end) {
//     return {
//       checkIn: data.reservation.checkIn,
//       checkOut: data.reservation.checkOut,
//       nights: data.nights,
//       adults: data.adults,
//       children: data.children?.map((child) => child.quantity).reduce((prev, acc) => prev + acc, 0) ?? undefined,
//       notes: data.notes,
//       customerCompanyId: data.customerCompanyId,
//       customerPersonId: data.customerPersonId,
//       isOptioned: data.isOptioned ?? false,
//       optionedExpirationDate: data.optionedExpirationDate,
//       sendEmailAfterInsert: data.sendEmailAfterInsert,
//       customerEmailAddress: data.customerEmailAddress,
//       credit: data.customerCompanyId ? data.credit : undefined,
//     } as ReservationFormData
//   }
//   return undefined
// }

const useReservationTimeInsertFormHook = ({ onSubmit, openReservation }: props) => {
  const { t } = useTranslation()
  const schema = getReservationTimeNewFormSchema(t)

  const customErrorMap = useCustomError()
  z.setErrorMap(customErrorMap)

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
    setError,
  } = useForm<ReservationTimeSchema>({ resolver: zodResolver(schema) })

  const submitHandler = useCallback(
    async (data: ReservationTimeSchema) => {
      const reservationFormData = data
      if (reservationFormData) {
        await onSubmit(reservationFormData)
      }
    },
    [onSubmit],
  )

  const onFormSubmit = useCallback(handleSubmit(submitHandler), [handleSubmit, submitHandler])

  const onFormSubmitAndOpenReservation = useCallback(
    async (data: ReservationTimeSchema) => {
      const validation = schema.safeParse(data)
      if (validation.success) {
        const reservationFormData = data // formSchemaAsReservationFormData(data)
        if (reservationFormData) {
          const result = await onSubmit(reservationFormData)

          if (result?.data?.createReservation && openReservation) {
            openReservation(result.data.createReservation.id)
          }
        }
      } else {
        validation.error.issues.map((issue) => {
          setError(issue.path.join('.') as FieldPath<ReservationTimeSchema>, { message: issue.message })
        })
        // setError(validation.error.issues[0].path.join('.') as FieldPath<ReservationTimeSchema>, { message: validation.error.issues[0].message })
      }
    },
    [onSubmit],
  )

  return { schema, errors, control, setValue, getValues, onFormSubmit, watch, onFormSubmitAndOpenReservation }
}

export default useReservationTimeInsertFormHook
